'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _titleSection = require('../common/title-section');

var _titleSection2 = _interopRequireDefault(_titleSection);

var _bodySection = require('../common/body-section');

var _bodySection2 = _interopRequireDefault(_bodySection);

var _ctaSection = require('../common/cta-section');

var _ctaSection2 = _interopRequireDefault(_ctaSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

module.exports = _react2['default'].createClass({
    displayName: 'Automate Workflow SEO Page',

    renderTitleSection: function renderTitleSection() {
        var titleSectionProps = {
            title: 'Using Online Digital Signatures to Sign Documents',
            subtitle: 'Create a HelloSign account to start signing now.',
            buttonText: 'Create My Free Account!'
        };
        return _react2['default'].createElement(_titleSection2['default'], _extends({}, titleSectionProps, this.props));
    },
    renderBodySection: function renderBodySection() {
        var headerClass = 'm-marketing-page--header';
        var listClass = 'm-marketing-page--list';
        return _react2['default'].createElement(
            _bodySection2['default'],
            null,
            _react2['default'].createElement(
                'h2',
                { className: headerClass },
                'Can I use HelloSign to automate my paperwork?'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'Yes! HelloSign enables users to automate paperwork and workflows through features like our automatic email reminders and the \u201CInsert Everywhere\u201D option which helps completes long paperwork quickly.  Features like these make it easy to follow-up on paperwork and streamline the signing process.'
            ),
            _react2['default'].createElement(
                'h2',
                { className: headerClass },
                'Why automate a workflow?'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'Imagine the next document that you need to get signed. Have one in mind? Traditionally, it might take you one or two days to get the signature you need. It\u2019d likely require printing, signing, and faxing. By automating the paperwork flow with eSignatures, you can shrink the signing process down to just a few minutes and clicks.'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'Not only does automating your workflow save you time and paper, it saves productive hours and resources.'
            ),
            _react2['default'].createElement(
                'h2',
                { className: headerClass },
                'What kind of workflows can I streamline using eSignatures?'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'All different types of workflows can be streamlined using eSignatures. For example:'
            ),
            _react2['default'].createElement(
                'ul',
                { className: listClass },
                _react2['default'].createElement(
                    'li',
                    null,
                    'Real estate agents can close deals onsite by having their clients sign paperwork on tablets or other mobile devices.'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    'Schools can automate the registration process by having their students sign online applications with legally-binding eSignatures.'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    'Sales teams seal can contracts faster by merging data from their CRM systems into online document templates. Psst\u2026 ',
                    _react2['default'].createElement(
                        'a',
                        {
                            href: 'http://blog.hellosign.com/hellosign-and-hubspot-join-forces/',
                            target: '_blank', rel: 'noopener noreferrer' },
                        'Check out how users are using the HelloSign + HubSpot integration to automate their sales document workflow'
                    ),
                    '.'
                )
            ),
            _react2['default'].createElement(
                'p',
                null,
                'That\u2019s not all! You can ',
                _react2['default'].createElement(
                    'a',
                    { target: '_blank', rel: 'noopener noreferrer',
                        href: 'http://blog.hellosign.com/category/general/customer-stories/' },
                    'read more about the different use cases here'
                ),
                '.'
            ),
            _react2['default'].createElement(
                'h2',
                { className: headerClass },
                'How do HelloSign electronic signatures work?'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'HelloSign makes it easy to electronically sign documents, send signature requests to others, and track where your documents are at all times. Here are just of few of the features that make it easy to automate your workflow:'
            ),
            _react2['default'].createElement(
                'ul',
                { className: listClass },
                _react2['default'].createElement(
                    'li',
                    null,
                    _react2['default'].createElement(
                        'strong',
                        null,
                        'Automatic email reminders.'
                    ),
                    ' You\u2019ll get a notification each and every time someone signs your document. This removes the need keep track of each eSignature and the possibility of misplaced documents.'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    _react2['default'].createElement(
                        'strong',
                        null,
                        'Audit trails.'
                    ),
                    ' Each signing activity is recorded for each document. These audit trails help you to automatically store important signer information in one location.'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    _react2['default'].createElement(
                        'strong',
                        null,
                        '\u201CInsert Everywhere\u201D option.'
                    ),
                    ' When signing a lengthy document, you may have multiple spots for signature and initials. The \u201CInsert Everywhere\u201D option makes it possible for signers to automate the signing process by inserting their signature into all the required signature fields. Learn more about this feature and our signing experience here.  ',
                    _react2['default'].createElement(
                        'a',
                        { target: '_blank', rel: 'noopener noreferrer',
                            href: 'http://blog.hellosign.com/new-signer-experience/' },
                        'Learn more about this feature and our signing experience here.'
                    )
                )
            ),
            _react2['default'].createElement(
                'h2',
                { className: headerClass },
                'What are some other ways to use HelloSign?'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'You can enable some of our partner integrations for an even smoother document workflow. Want to sign from your email account? No problem. Sign a document stored in Dropbox? A-OK.'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'Here are just a few examples of our favorite integrations:'
            ),
            _react2['default'].createElement(
                'ul',
                { className: listClass },
                _react2['default'].createElement(
                    'li',
                    null,
                    'Google (including ',
                    _react2['default'].createElement(
                        'a',
                        { href: 'https://www.hellosign.com/gmail',
                            target: '_blank', rel: 'noopener noreferrer' },
                        'Gmail'
                    ),
                    ', ',
                    _react2['default'].createElement(
                        'a',
                        { href: 'https://www.hellosign.com/googledrive',
                            target: '_blank', rel: 'noopener noreferrer' },
                        'Google Drive'
                    ),
                    ', and ',
                    _react2['default'].createElement(
                        'a',
                        {
                            href: 'https://www.hellosign.com/google-docs-add-on', target: '_blank', rel: 'noopener noreferrer' },
                        'Google Docs'
                    ),
                    ')'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    _react2['default'].createElement(
                        'a',
                        { href: 'http://blog.hellosign.com/hellosign-integrates-with-evernote/',
                            target: '_blank', rel: 'noopener noreferrer' },
                        'Evernote'
                    )
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    _react2['default'].createElement(
                        'a',
                        { href: 'http://blog.hellosign.com/dropbox/', target: '_blank', rel: 'noopener noreferrer' },
                        'Dropbox'
                    )
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    _react2['default'].createElement(
                        'a',
                        { href: 'http://blog.hellosign.com/hellosign-launches-integration-with-slack/',
                            target: '_blank', rel: 'noopener noreferrer' },
                        'Slack'
                    )
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    'Zapier'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    _react2['default'].createElement(
                        'a',
                        { href: 'http://blog.hellosign.com/hellosign-and-hubspot-join-forces/',
                            target: '_blank', rel: 'noopener noreferrer' },
                        'HubSpot CRM'
                    )
                )
            )
        );
    },
    renderCTASection: function renderCTASection() {
        var ctaSectionProps = {
            title: 'Get Started',
            subtitle: 'Document automation reduces loss of time, loss of resources, and loss of mental bandwidth. Gain back the loss by automating! We’re happy to get you  started.',
            signupButtonText: 'CREATE A FREE HELLOSIGN ACCOUNT',
            signupButtonUrl: this.props.homeUrl,
            secondButtonText: 'SEE PRO PLANS',
            secondButtonUrl: this.props.pricingUrl
        };
        return _react2['default'].createElement(_ctaSection2['default'], _extends({}, ctaSectionProps, this.props));
    },
    render: function render() {
        return _react2['default'].createElement(
            'div',
            null,
            this.renderTitleSection(),
            this.renderBodySection(),
            this.renderCTASection()
        );
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/seo/automate-workflow.jsx
 ** module id = 1217
 ** module chunks = 0
 **/